import angular from "angular";
import moment from "moment";
import { directiveFactory, IScopeBoundController } from "../angular-core";

const scope = {
    ngModel: "=",
    ngChange: "&",
    inputClass: "<",
    inputGroupClass: "<",
    ngRequired: "<",
    ngDisabled: "<",
    inputName: "<",
    allowClear: "<"
};

class YearSelectorController implements IScopeBoundController<typeof scope> {
    static $inject = ["$scope", "$timeout"];

    ngModel: number | null;
    ngChange: Function;
    inputClass: string;
    inputGroupClass: string;
    ngRequired: boolean;
    ngDisabled: boolean;
    inputName: string;
    allowClear: boolean;
    date: Date | null;

    dateChanged = () => {
        this.ngModel = this.date ? this.date.getFullYear() : null;

        this.$timeout(() => this.ngChange());
    };

    constructor(protected $scope: ng.IScope, protected $timeout: ng.ITimeoutService) {
        $scope.$watch("$ctrl.ngModel", (newYear: number) => {
            if (!(this.date instanceof Date && this.date.getFullYear() == newYear)) {
                this.date = newYear == null ? null : moment.utc(`${newYear}/01/01`, "YYYY/MM/DD").toDate();
            }
        });
    }
}

export class YearSelectorDirective implements ng.IDirective<ng.IScope> {
    static componentName: string = "yearSelector";

    restrict = "E";
    scope = scope;

    controllerAs = "$ctrl";
    bindToController = true;
    controller = YearSelectorController;

    constructor() {}

    template = `<p class="input-group" ng-class="$ctrl.allowClear ? '' : 'hide-clear' + $ctrl.inputGroupClass">
            <input type="text" ng-attr-name='{{$ctrl.inputName}}' class="form-control" ng-class="$ctrl.inputClass"
                uib-datepicker-popup="yyyy" ng-model="$ctrl.date" ng-change="$ctrl.dateChanged()"
                datepicker-options="{minMode: 'year'}" ng-model-options="{ timezone  : 'UTC'}"
                ng-required="$ctrl.ngRequired" is-open="popup1.opened"
                ng-disabled="$ctrl.ngDisabled" clear-text="{{ 'CLEAR' | translate}}" current-text="{{ 'CURRENT_YEAR' | translate}}"
                close-text="{{ 'CLOSE' | translate}}"/>
            <span class="input-group-btn">
                <button type="button" class="btn btn-default" ng-click="popup1.opened = true;" ng-disabled="$ctrl.ngDisabled">
                    <i class="glyphicon glyphicon-calendar"></i>
                </button>
            </span>
        </p>`;
}

angular
    .module("topline.directives")
    .directive(YearSelectorDirective.componentName, directiveFactory(YearSelectorDirective));
